import { gql, useMutation } from '@apollo/client'

const useUpdateGlobalVars = (onSuccess = () => {}, onError = () => {}) => {
  return useMutation(
    gql`
      mutation($globalVarsUpdates: [UpdateGlobalVarItemInput!]!) {
        updateGlobalVars(globalVarsUpdates: $globalVarsUpdates) {
          id
          type
          name
        }
      }
    `,
    {
      onCompleted: onSuccess,
      onError
    }
  )
}

export default useUpdateGlobalVars
